import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Import Routes and Route components
import Login from './Components/Auth/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import Dashboard from './Components/Dashboard/Dashboard';
import Menuitems from './Components/Pages/Menuitems';
import Advertisement from './Components/Pages/Advertisement';


function App() {
  return (
    <Router>
      <Routes>

        <Route path="/" element={<Login />} />
        <Route path="/dash-bo/ard-dash/board/346734/dashboard" element={<Dashboard />} />
        <Route path="/menu-item-s/menu-items/tems/346734/menuitems" element={<Menuitems />} />
        <Route path='/advertise' element={<Advertisement/>}/>
      </Routes>
    </Router>
  );
}

export default App;
